
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M18.8899 4.99997H18.3599L19.0699 3.02997C19.3099 2.37997 18.9699 1.65997 18.3199 1.42997C17.6699 1.18997 16.9499 1.52997 16.7099 2.17997L15.6899 4.99997H5.09992C3.72992 4.99997 2.76992 6.33997 3.19992 7.62997L4.99992 13L3.20992 18.37C2.76992 19.66 3.73992 21 5.09992 21H18.8799C20.2399 21 21.2099 19.66 20.7799 18.37L18.9999 13L20.7799 7.62997C21.2099 6.33997 20.2499 4.99997 18.8899 4.99997ZM14.9999 14H12.9999V16C12.9999 16.55 12.5499 17 11.9999 17C11.4499 17 10.9999 16.55 10.9999 16V14H8.99992C8.44992 14 7.99992 13.55 7.99992 13C7.99992 12.45 8.44992 12 8.99992 12H10.9999V9.99997C10.9999 9.44997 11.4499 8.99997 11.9999 8.99997C12.5499 8.99997 12.9999 9.44997 12.9999 9.99997V12H14.9999C15.5499 12 15.9999 12.45 15.9999 13C15.9999 13.55 15.5499 14 14.9999 14Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-local-pharmacy`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconLocalPharmacy

    ```js
    <b-new-b-icon-local-pharmacy />
    ```
</docs>


